import { FormSelect, FormTextField } from "common/components";
import { addFlowStepPrefix } from "common/utils";
import { CreditNoteReasonFlowData, CreditNoteReasonFlowStep } from "core/api";
import { useTranslation } from "i18n";
import { FlowStepComponentProps } from "../models";
import { StyledStepContentWrapper } from "../steps.styles";

export type CreditNoteTextProps = FlowStepComponentProps<
  CreditNoteReasonFlowStep,
  CreditNoteReasonFlowData
>;

/** Credit Note Reason step component */
export function CreditNoteReason({
  control,
  data,
  flowStep,
}: CreditNoteTextProps): JSX.Element {
  const { t } = useTranslation(["invoice"]);
  const { text, creditReason, creditReasons, maxNoOfCharsPerRow, maxNoOfRows } =
    data;

  const DEFAULT_ROWS = 8;

  return (
    <StyledStepContentWrapper>
      <FormSelect
        label={t("invoice:creditNoteReason.creditReason")}
        control={control}
        fieldName={addFlowStepPrefix(flowStep, "creditReason")}
        validValues={creditReasons}
        defaultValue={creditReason.id}
      />

      <FormTextField
        fieldName={addFlowStepPrefix(flowStep, "text")}
        control={control}
        label={t("invoice:creditNoteReason.text")}
        multiline
        defaultValue={text}
        rows={DEFAULT_ROWS}
        data-cy="creditNoteText"
        customValidation={(value: string) => {
          const lines = value?.split("\n");
          if (lines?.length > maxNoOfRows) {
            return t("invoice:creditNoteReason.maxRows", {
              count: maxNoOfRows,
            });
          }
          if (lines?.some((line) => line?.length > maxNoOfCharsPerRow)) {
            return t("invoice:creditNoteReason.maxCharsPerRow", {
              count: maxNoOfCharsPerRow,
            });
          }
          return true;
        }}
      />
    </StyledStepContentWrapper>
  );
}
